import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormFieldContext } from '../form-field/form-field.context';

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifLabel = (props) => {
  const { children, className = '', ...other } = props;
  const { isFocused, invalid, disabled, formElementType, required, id } = useContext(
    FormFieldContext
  );

  const classes = classNames({
    'motif-label': true,
    'motif-focus': isFocused,
    'motif-invalid': invalid,
    'motif-disabled': disabled,
    'motif-label-for-text': formElementType === 'textInput',
    'motif-label-for-slider': formElementType === 'slider',
    'motif-label-for-numeric-input': formElementType === 'number',
    'motif-label-required': required,
    [className]: true
  });

  return (
    <label {...other} className={classes} htmlFor={id} data-motif-label>
      {children}
    </label>
  );
};

MotifLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export { MotifLabel };
